// src/modules/app-views/leads/pages/Init/components/tableColumns/distributionColumn.js
import { Tag } from 'antd';
import translateX from 'utils/translateX';

function distributionColumn(buildColumnProps, options = {}) {
  const {
    key = 'distribution',
    title = 'distribution',
    dataIndex = 'distributionMode',
    width = 130,
    align = 'center',
    columnProps = { sort: false },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const mode = r?.distributionMode;
      if (!mode) return '—';
      const cfg = {
        marketplace: { color: 'purple',   label: 'marketplace' },
        supervised:  { color: 'geekblue', label: 'supervised' },
      };
      const { color, label } = cfg[mode] || { color: 'default', label: mode };
      return <Tag color={color}>{translateX(label)}</Tag>;
    },
  };
}

export default distributionColumn;
